import React, { useCallback, useEffect, useState } from "react";
import {
  Select,
  Form,
  Button,
  Table,
  Input,
  Pagination,
  message,
  Space,
  Modal,
  Radio,
  InputNumber,
  Upload,
} from "antd";
import { SearchOutlined, RedoOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import {
  getLevelList,
  addLevel,
  setLevel,
  delLevel,
  uploadFile,
} from "@root/common/service";

interface DataType {
  key: number | string;
  name: string;
  sortNum: number | string;
  publishStatus: string;
  updateTime: number | string;
}
const { Option } = Select;

function FirstLevel(props: any) {
  const columns: ColumnsType<DataType> = [
    {
      title: "栏目名称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "排序",
      dataIndex: "sortNum",
      key: "sortNum",
    },
    {
      title: "发布状态",
      dataIndex: "publishStatus",
      key: "publishStatus",
      render: (_, a) => (
        <>
          {(() => {
            if (a.publishStatus == "Y") {
              return "发布";
            } else {
              return "未发布";
            }
          })()}
        </>
      ),
    },
    {
      title: "最后一次操作时间",
      dataIndex: "updateTime",
      key: "updateTime",
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Space size="middle">
          <Button style={{ padding: "0" }} onClick={() => toTab(e)} type="link">
            二级栏目
          </Button>
          <Button
            style={{ padding: "0" }}
            onClick={() => edit(e)}
            type="link"
            // disabled={e.publishStatus === "Y"}
          >
            编辑
          </Button>
          <Button
            style={{ padding: "0" }}
            onClick={() => del(e)}
            type="link"
            disabled={e.publishStatus === "Y"}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [current, setCurrent] = useState(1);
  const [data, setData] = useState<DataType[]>();
  const [total, setTotal] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pathDisabled, setPathDisabled] = useState(true);
  const [modalTitle, setModalTitle] = useState("添加栏目");
  const [pathTitle, setPathTitle] = useState("外链地址");
  const [editItem, setEditItem] = useState<any>({});
  const [imgUrl, setImgUrl] = useState<any>("");
  const [topSortDisabled, setTopSortDisabled] = useState(true);
  const [mobileSortDisabled, setMobileSortDisabled] = useState(true);

  useEffect(() => {
    getTableData();
  }, [current]);

  const getTableData = async (e: string = "") => {
    const { rows, total } = await getLevelList(
      `${e}baseNewsColumnLevel=1&pageNum=${current}&pageSize=10`
    );
    rows.forEach((e: any, index: number) => {
      e.key = index;
    });
    setData(rows);
    setTotal(total);
  };

  const onFinish = useCallback((e: any) => {
    const keys: Array<string> = Object.keys(e);
    const values = Object.values(e);
    const str: string = values.reduce(function (r: string, el, i) {
      if (!!el) {
        r += `${keys[i]}=${el}&`;
      }
      return r;
    }, "");
    getTableData(str);
  }, []);

  const onFinishFailed = useCallback((e: any) => {
    console.log(e);
  }, []);

  const onReset = useCallback(() => {
    setCurrent(1);
    form1.resetFields();
    getTableData();
  }, [form1]);

  const add = (): void => {
    setModalTitle("添加栏目");
    setPathDisabled(true);
    setIsModalOpen(true);
  };

  const onChange = (e: any) => {
    setCurrent(e);
    getTableData();
  };

  const pathChange = (e: any) => {
    if (e.target.value == "Y") {
      setPathDisabled(false);
      setPathTitle("外链地址");
    } else {
      setPathDisabled(false);
      setPathTitle("路由地址");
    }
  };

  const toTab = (e: any): void => {
    console.log(e);
    props.setKey("2");
    props.setSecondId(e.id);
  };

  const edit = (e: any): void => {
    setModalTitle("修改栏目");
    setPathDisabled(false);
    setImgUrl(e.imageUrl);
    form2.setFieldsValue({
      name: e.name,
      sortNum: e.sortNum,
      publishStatus: e.publishStatus,
      menuType: e.menuType,
      baseNewsColumnType: e.baseNewsColumnType,
      isFrame: e.isFrame,
      path: e.path,
      mobileStatus: e.mobileStatus,
      mobileSortNum: e.mobileSortNum,
      topStatus: e.topStatus,
      topSortNum: e.topSortNum,
      imageUrl: e.shortUrl,
    });
    setEditItem(e);
    setIsModalOpen(true);
  };

  const del = async (e: any) => {
    const { code, msg } = await delLevel(e.id);
    if (code == 200) {
      getTableData();
      message.success("删除成功");
    } else {
      message.error(msg);
    }
  };

  const handleCancel = useCallback(() => {
    form2.resetFields();
    setIsModalOpen(false);
  }, []);

  const handleOk = useCallback(
    async (e: any) => {
      console.log(e);
      if (modalTitle == "修改栏目") {
        const { code, msg } = await setLevel({
          ...e,
          id: editItem.id,
        });
        if (code == 200) {
          message.success("修改成功");
          setIsModalOpen(false);
          getTableData();
          form2.resetFields();
        } else {
          message.error(msg);
        }
      } else {
        const { code, msg } = await addLevel({
          ...e,
          parentId: 0,
          baseNewsColumnLevel: 1,
        });
        if (code == 200) {
          message.success("添加成功");
          setIsModalOpen(false);
          getTableData();
          form2.resetFields();
        } else {
          message.error(msg);
        }
      }
    },
    [modalTitle, editItem]
  );

  const handleChange = (e: any, a: any) => {
    console.log("选择结果", e, a);
  };

  const topSortChange = (e: any) => {
    if (e.target.value == "Y") {
      setTopSortDisabled(false);
    } else {
      setTopSortDisabled(true);
    }
  };

  const topSortChange1 = (e: any) => {
    if (e.target.value == "Y") {
      setMobileSortDisabled(false);
    } else {
      setMobileSortDisabled(true);
    }
  };

  const uploadChange = async (data: any) => {
    const { file } = data;

    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      message.error("请选择正确的文件");
      return false;
    }
    if (file.size / 1024 / 1024 > 1) {
      message.error("请选择正确的文件");
      return false;
    }

    let width = 0;
    let height = 0;

    const checkSize = function () {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = function () {
          resolve({ width: image.width, height: image.height });
        };
      });
    };
    await checkSize()
      .then((res: any) => {
        width = res.width;
        height = res.height;
      })
      .catch((err) => {
        console.log(err);
        message.error("图片解析错误");
      });

    if (width !== 580 || height !== 150) {
      console.log("width--", width, "height--", height);
      message.error("请上传宽580px、高150px的图片");
      return false;
    }

    let formData = new FormData();
    formData.append("file", file);
    formData.append("uploadFileType", "image");
    formData.append("folder", "course");

    uploadFile(formData).then((res) => {
      setImgUrl(res.shortUrl);
      form2.setFieldsValue({ imageUrl: res.shortUrl });
    });
  };

  return (
    <>
      <div className="top">
        <Form
          name="firstLevelSearch"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="栏目名称" name="name">
            <Input placeholder="请输入内容" style={{ width: 180 }} />
          </Form.Item>

          <Form.Item label="发布状态" name="publishStatus">
            <Select
              placeholder="请选择"
              onChange={handleChange}
              allowClear
              style={{ width: 180 }}
            >
              <Option value="Y">发布</Option>
              <Option value="N">未发布</Option>
            </Select>
          </Form.Item>

          <Form.Item style={{ marginLeft: "30px" }}>
            <Button className="searchBtn" type="primary" htmlType="submit">
              <SearchOutlined />
              查询
            </Button>
            <Button
              className="resetBtn"
              type="primary"
              onClick={onReset}
              style={{ marginLeft: "15px" }}
            >
              <RedoOutlined />
              重置
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className="midBtn">
        <Button type="primary" onClick={() => add()}>
          添加
        </Button>
      </div>

      <div className="tableBottom">
        <Table
          size="middle"
          pagination={false}
          columns={columns}
          dataSource={data}
        />
        <Pagination
          current={current}
          onChange={onChange}
          total={total}
          showSizeChanger={false}
        />
      </div>

      <Modal
        title={modalTitle}
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        bodyStyle={{ display: "flex", justifyContent: "center" }}
      >
        <Form
          name="addFirstLevel"
          initialValues={{}}
          onFinish={handleOk}
          autoComplete="off"
          form={form2}
        >
          <Form.Item
            label="栏目名称"
            name="name"
            rules={[{ required: true, message: "名称不可为空!" }]}
          >
            <Input
              placeholder="最多四个字"
              style={{ width: 180 }}
              maxLength={4}
            />
          </Form.Item>

          <Form.Item
            label="排列顺序"
            name="sortNum"
            rules={[{ required: true, message: "顺序不可为空!" }]}
          >
            <InputNumber min={1} style={{ width: 180 }} />
          </Form.Item>

          <Form.Item
            label="发布状态"
            name="publishStatus"
            rules={[{ required: true, message: "发布状态不可为空!" }]}
          >
            <Radio.Group>
              <Radio value="Y">发布</Radio>
              <Radio value="N">未发布</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="菜单类型"
            name="menuType"
            rules={[{ required: true, message: "菜单类型不可为空!" }]}
          >
            <Radio.Group>
              <Radio value="C">菜单</Radio>
              <Radio value="F">按钮</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="内容类型"
            name="baseNewsColumnType"
            rules={[{ required: true, message: "内容类型不可为空!" }]}
          >
            <Select
              placeholder="请选择"
              onChange={handleChange}
              allowClear
              style={{ width: 180 }}
            >
              <Option value="VIDEO">视频</Option>
              <Option value="NEWS">新闻</Option>
              {/* <Option value="NO">无内容</Option> */}
            </Select>
          </Form.Item>

          <Form.Item
            label="是否外链"
            name="isFrame"
            rules={[{ required: true, message: "不可为空!" }]}
          >
            <Radio.Group onChange={pathChange}>
              <Radio value="Y">是</Radio>
              <Radio value="N">否</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label={pathTitle}
            name="path"
            rules={[{ required: true, message: "路径地址不可为空!" }]}
          >
            <Input
              disabled={pathDisabled}
              placeholder="请输入内容"
              style={{ width: 180 }}
            />
          </Form.Item>

          <Form.Item
            label="是否在移动端展示"
            name="mobileStatus"
            rules={[{ required: true, message: "不可为空!" }]}
          >
            <Radio.Group onChange={topSortChange1}>
              <Radio value="Y">是</Radio>
              <Radio value="N">否</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="移动端的展示顺序"
            name="mobileSortNum"
            rules={[
              { required: !mobileSortDisabled, message: "顺序不可为空!" },
            ]}
          >
            <InputNumber
              disabled={mobileSortDisabled}
              min={1}
              style={{ width: 180 }}
            />
          </Form.Item>

          <Form.Item
            label="是否在首页展示"
            name="topStatus"
            rules={[{ required: true, message: "不可为空!" }]}
          >
            <Radio.Group onChange={topSortChange}>
              <Radio value="Y">是</Radio>
              <Radio value="N">否</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="栏目图片"
            name="imageUrl"
            valuePropName="imageUrl"
            rules={[{ required: !topSortDisabled, message: "图片不可为空!" }]}
          >
            {imgUrl && (
              <img
                style={{ width: "328px", height: "216px" }}
                src={imgUrl}
                alt=""
              />
            )}
            <Upload
              maxCount={1}
              showUploadList={false}
              customRequest={uploadChange}
            >
              <p>* 支持1M以内JPG、PNG，请上传宽580px、高150px的图片</p>
              <Button disabled={topSortDisabled}>选择文件</Button>
            </Upload>
          </Form.Item>

          <Form.Item
            label="首页的展示顺序"
            name="topSortNum"
            rules={[{ required: !topSortDisabled, message: "顺序不可为空!" }]}
          >
            <InputNumber
              disabled={topSortDisabled}
              min={1}
              style={{ width: 180 }}
            />
          </Form.Item>

          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
            <Button onClick={handleCancel} style={{ marginRight: "15px" }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              确定
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default FirstLevel;
